import type { CustomIconProps } from '../CustomIcon';

export const CheckIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  size = 24,
  solid,
  ...props
}: CustomIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <rect x='0.5' width='24' height='24' rx='12' fill='#DDF3ED' />
    <path
      d='M17.8334 8L10.5 15.3333L7.16669 12'
      stroke='#007F59'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
